export default "{\n    \"label\": \"Categoría\"\n}"